module.exports = __webpack_public_path__ + "static/media/waves-29-39.c1567139.jpg";